{
  "name": "qtime-angular",
  "version": "1.26.0",
  "license": "UNLICENSED",
  "scripts": {
    "start": "ng serve",
    "build": "ng build --configuration production",
    "build:staging": "ng build",
    "load-aws-amplify-env": "ts-node load-aws-amplify-env.ts",
    "e2e": "cross-env E2E_LOG_LEVEL=silent playwright test --config=e2e/playwright.config.ts",
    "e2e:debug": "cross-env E2E_LOG_LEVEL=debug playwright test --config=e2e/playwright.config.ts",
    "e2e:headed": "cross-env E2E_LOG_LEVEL=silent playwright test --config=e2e/playwright.config.ts --headed",
    "e2e:headed:debug": "cross-env E2E_LOG_LEVEL=debug playwright test --config=e2e/playwright.config.ts --headed",
    "e2e:broadcast": "cross-env E2E_LOG_LEVEL=silent playwright test --config=e2e/playwright.config.ts --headed --grep \"token lifecycle\"",
    "e2e:broadcast:debug": "cross-env E2E_LOG_LEVEL=debug playwright test --config=e2e/playwright.config.ts --headed --grep \"token lifecycle\"",
    "e2e:report": "playwright show-report",
    "test": "vitest run",
    "test:watch": "vitest",
    "lint": "ng lint"
  },
  "engines": {
    "node": ">=18.17.0"
  },
  "author": "Qtime AS",
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.12",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/compiler-cli": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/platform-server": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@sentry/angular": "^10.55.0",
    "date-fns": "^2.30.0",
    "font-awesome": "4.7.0",
    "hammer-timejs": "1.1.0",
    "hammerjs": "2.0.8",
    "howler": "2.0.4",
    "intl": "1.2.5",
    "ng-qrcode": "^17.0.0",
    "normalize.css": "5.0.0",
    "pusher-js": "^7.0.0",
    "rxjs": "^7.8.2",
    "sweetalert2": "6.6.1",
    "ts-helpers": "1.1.1",
    "tslib": "^2.0.0",
    "web-animations-js": "^2.3.2",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.17",
    "@angular-eslint/builder": "17.5.3",
    "@angular-eslint/eslint-plugin": "17.5.3",
    "@angular-eslint/eslint-plugin-template": "17.5.3",
    "@angular-eslint/schematics": "17.5.3",
    "@angular-eslint/template-parser": "17.5.3",
    "@angular/cli": "^17.3.17",
    "@playwright/test": "^1.44.1",
    "@sentry/cli": "^3.4.3",
    "@types/howler": "2.0.3",
    "@types/node": "^20.19.43",
    "@types/pusher-js": "^4.2.2",
    "@typescript-eslint/eslint-plugin": "^7.2.0",
    "@typescript-eslint/parser": "^7.2.0",
    "cross-env": "^7.0.3",
    "dotenv": "^16.0.3",
    "eslint": "^8.57.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "39.9.1",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jsdom": "^29.1.1",
    "ts-node": "^10.9.1",
    "typescript": "~5.4.5",
    "vitest": "^3.2.7"
  }
}
